import React from "react";

export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
            // aria-expanded="false"
          >
            {/* {" "}
            <span className="sr-only">Toggle navigation</span>{" "} */}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
            AAAA 2025
          </a>{" "}
        </div>
        <div
          className=" collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#welcome" className="page-scroll">
                Welcome
              </a>
            </li>
            <li>
              <a href="#venue" className="page-scroll">
                Venue
              </a>
            </li>
            <li>
              <a href="#program" className="page-scroll">
                Program
              </a>
            </li>
            <li>
              <a href="#info" className="page-scroll">
                Congress Info
              </a>
            </li>
            <li>
              <a href="#keynote" className="page-scroll">
                Keynote Speakers
              </a>
            </li>
            <li>
              <a href="#registration" className="page-scroll">
                Registration
              </a>
            </li>
            <li>
              <a href="#proceedings" className="page-scroll">
                Proceedings
              </a>
            </li>
            <li>
              <a href="#sponsors" className="page-scroll">
                Sponsors
              </a>
            </li>
            <li>
              <a href="#award" className="page-scroll">
                Award
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll">
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
